// src/app/app.tsx
'use client';

import { PrimeReactProvider } from 'primereact/api';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import { LayoutProvider } from './layout/context/LayoutContext';
import PublicLayout from './layout/public-layout/PublicLayout';

import '../i18n/config';

const LayoutSelector: React.FC = () => {
  // const { isLoggedIn } = useAuth();
  // return isLoggedIn ? <PrivateLayout /> : <PublicLayout />;
  return <PublicLayout />;
};

// const App = ({ children }: RootLayoutProps) => (
const App: React.FC = () => {
  return (
    <PrimeReactProvider>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <AuthProvider>
          <HelmetProvider>
            <LayoutProvider>
              <LayoutSelector />
            </LayoutProvider>
          </HelmetProvider>
        </AuthProvider>
      </Router>
    </PrimeReactProvider>
  );
};

export default App;
